import { render, staticRenderFns } from "./loginConfirmDialog.vue?vue&type=template&id=b495e654&scoped=true"
import script from "./loginConfirmDialog.vue?vue&type=script&lang=js"
export * from "./loginConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./loginConfirmDialog.vue?vue&type=style&index=0&id=b495e654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b495e654",
  null
  
)

export default component.exports